import React, { useRef, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { Grid, Button, Typography, Box, Link } from "@mui/material";
import { SIGN_IN } from "../api";
import { ReactComponent as Logo1 } from "../assets/images/Logo_1.svg";
import { useDispatch } from "react-redux";
import { useAuth } from "../hooks";
import { addErrorMessage, addNewMessage } from "../slice";
import Input from "../components/Input";
import ReCAPTCHA from "react-google-recaptcha";
import Footer from "./Footer";

function SignIn() {
  const dispatch = useDispatch();
  const { signIn } = useAuth();
  const recaptcha = useRef();
  const [captchaToken, setCaptchaToken] = useState();
  const [showErrors, setShowErrors] = useState({ username: false, password: false });

  const { mutate: signInRequest } = useMutation((body) => SIGN_IN.post(body), {
    onError: ({ response: { data } }) => {
      dispatch(
        addNewMessage({
          id: "wrong-password",
          text: data.error,
          type: "error",
        })
      );
      recaptcha.current.reset();
    },
    onSuccess: ({ data }) => {
      signIn({
        refresh: data.refresh_token,
        access: data.access_token,
      });
    },
  });

  const handleSubmitForm = (event) => {
    event.preventDefault();
    let body = {
      password: event.target.password.value,
      username: event.target.username.value,
    };

    if (event.target.password.value !== "" && event.target.username.value !== "") {
      if (recaptcha.current.getValue()) signInRequest({ ...body, captcha_token: captchaToken });
      else
        dispatch(
          addErrorMessage({ status: 400, data: { message: "لطفا من ربات نیستم را انتخاب کنید." } })
        );
    } else {
      setShowErrors({
        username: event.target.username.value === "",
        password: event.target.password.value === "",
      });
    }
  };

  return (
    <Grid
      container
      maxWidth="1920px"
      width="100%"
      minHeight="100dvh"
      bgcolor={{ xs: "#fff", sm: "#FAFAFA", md: "#FAFAFA" }}
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      alignItems="center"
      overflow="auto"
    >
      <Grid
        container
        minHeight="90dvh"
        height="90dvh"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <Box
          xs={4}
          bgcolor="#fff"
          borderRadius={5}
          display="flex"
          justifyContent="center"
          alignItems="center"
          boxSizing="border-box"
          flexDirection="column"
          py={{ xs: 1, sm: 2, md: 4 }}
          px={{ xs: 1, sm: 4, md: 6 }}
          my={5}
        >
          <Logo1 />
          <Typography variant="h1" mt={2} mb={1}>
            ورود
          </Typography>
          <Typography variant="h2" my={1} textAlign="center">
            برای ورود شماره تلفن خود را وارد کنید
          </Typography>
          <form
            onSubmit={handleSubmitForm}
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Grid container flexDirection="row-reverse" sx={{ width: "100%", maxWidth: "248px" }}>
              <Grid item xs={12} sm={12} md={12} lg={12} sx={Style.itemGrid}>
                <Input
                  placeholder="شماره تلفن"
                  name="username"
                  flex={4}
                  type="text"
                  error={showErrors.username}
                  onChange={() => setShowErrors({ ...showErrors, username: false })}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} sx={Style.itemGrid}>
                <Input
                  placeholder="رمز عبور"
                  type="password"
                  name="password"
                  flex={4}
                  error={showErrors.password}
                  onChange={() => setShowErrors({ ...showErrors, password: false })}
                />
              </Grid>
            </Grid>
            <Grid
              container
              className="captcha"
              style={{ transform: "scale(0.815)", transformOrigin: "0 0", marginTop: "0.25rem" }}
            >
              <ReCAPTCHA
                sitekey="6LfjzkopAAAAAMVFkngsSsFNBRsNZin7b991NfVA"
                ref={recaptcha}
                style={{
                  width: "30px",
                }}
                hl="fa"
                onChange={(token) => {
                  setCaptchaToken(token);
                }}
              ></ReCAPTCHA>
            </Grid>
            <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
              <Link
                href="/sign-in/forget-password"
                underline="none"
                fontSize="14px"
                color="#4C466F"
              >
                فراموشی رمز عبور
              </Link>
              <Button type="submit" variant="l" sx={{ my: { xs: 2, xl: 3 } }}>
                ورود
              </Button>
            </Box>
          </form>
          <Box display="flex" alignItems="baseline">
            <Link
              href="/sign-up"
              underline="none"
              fontSize="14px"
              color="rgba(0, 0, 0, 0.6)"
              mr={1}
            >
              ثبت نام کنید
            </Link>
            <Typography variant="h2" color="rgba(0, 0, 0, 0.6)">
              حساب کاربری ندارید؟
            </Typography>
          </Box>
        </Box>
      </Grid>
      <Footer />
    </Grid>
  );
}

const Style = {
  itemGrid: {
    boxSizing: "border-box",
    margin: "4px 0",
  },
};

export default SignIn;
